import notice from "./notice"
import axios from 'axios';
import units from './units';

const CancelToken = axios.CancelToken;

function request(params) {
  if (!params.url && !params.href) return;
  return new Promise((resolve, reject) => {
    let data = getParams(params);
    let query = getQuerys(params.query);
    var root = ""; //获取基础域名
    let headers = params.headers || "";
    let method = 'POST';
    if (params.type) {
      method = params.type.toUpperCase();
    }
    if (params.href) {
      params.url = params.href
    }
    if(params.apiPermissionCode){
      headers == ""?headers = {}:'';
      headers.apiPermissionCode = params.apiPermissionCode;
    }
    let obj = {}
    if (!params.body) {
      obj = {
        method: method,
        url: params.url + query,
        data: method === 'POST' || method === 'PUT' || method === 'DELETE' ? data : null,
        params: method === 'GET' ? data : null,
        baseURL: root,
        headers: headers,
        onUploadProgress: params.onUploadProgress,
        responseType: params.responseType || '',
        /**end */
        withCredentials: true,
        cancelToken: new CancelToken(function executor(c) {
        units.$httpRequestList.push(c);
        units.$httpRequestList=units.$httpRequestList.slice(-10);//只保留最新的10个请求
      }),
      }
    } else {
      obj = {
        method: method,
        url: params.url + query,
        data: data,
        baseURL: root,
        headers: headers,
        onUploadProgress: params.onUploadProgress,
        responseType: params.responseType || '',
        /**end */
        withCredentials: true,
        cancelToken: new CancelToken(function executor(c) {
        units.$httpRequestList.push(c);
        units.$httpRequestList=units.$httpRequestList.slice(-10);//只保留最新的10个请求
      }),
      }
    }
    return axios(obj)
      .then(function (res) {
        let headerCheck = useHeader(res.headers);
        if (!headerCheck) {
          resolve(res.data);
          return;
        }
        if (params.forced) {
          if (params.All) {
            resolve(res)
          } else {
            resolve(res.data)
          }
          return;
        }
        let isErr = hasError(res.data, params);
        if (isErr) {
          reject(res.data)
        } else {
          if (params.responseType && params.responseType == 'blob') {
            resolve(res)
          } else {
            resolve(res.data)
          }
        }

      })
      .catch(function (err) {
        let res = err.response
        reject(err)
        if (res) {
          window.alert('api error, HTTP CODE: ' + res.status)
        }
      })

  });
};

function useHeader(header) {
  // 通过header判断是否授权
  if (API_CONFIG.CHANNEL != "EPPS") return true;
  if (header.authed == "n") {
    epps_login.init({
      env: 0
    });
    return false;
  }
  return true;
}

// 接口参数校验和转换
function getParams(params) {
  let result;
  if (params.data) {
    result = filterNull(params.data)
  }
  if (params.contentType == 'from') {
    result = getURLSearchParams(result)
  }
  return result;
}
// 拼接接口后缀参数
function getQuerys(data) {
  if (!data) return "";
  let query = "";
  _.forIn(data, function (value, key) {
    query += query ? `&${key}=${value}` : `?${key}=${value}`
  });
  return query;
}
//公共错误处理
function hasError(data, params) {
  if (params.responseType && params.responseType == 'blob') {
    return false
  }
  if (data.httpCode == 200 || data.httpCode == 1) {
    return false
  }
  if (data.httpCode == -1 || data.httpCode == 40400) {
    //登陆过期
    localStorage.removeItem('hasLogin')
    //iframe父页面跳转login
    units.goLogin();
    return true
  }
  if (data.httpCode == 403) {
    setLayer(data.data)
    return true;
  }
  if (data.httpCode > 300 && data.data) {
    setLayer(data.data.errorMsg)
    return true;
  } else {
    setLayer(data.msg)
    return true;
  }
}

function setLayer(msg) {
  notice.error(msg)
}
// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}
// 表单提交字段转换
function getURLSearchParams(params) {
  // 参数转换
  if (!params) return;
  let param = new URLSearchParams();
  for (var i in params) {
    param.append(i, params[i])
  }
  return param
}

export default request
